import React from 'react';
import { useLettersForm } from '../provider/LettersFormContext';
import { CareMapprTextarea } from '../../../../../components/Inputs/textarea';
import MedicationChanges from './MedicationChanges';
import SummaryRecommandation from './SummaryRecommandation';
import { LetterType } from '../PharmacistDoctorLetterSection';
import MonitoringRequired from './MonitoringRequired';
import CareMapprButton from '../../../../../components/Button/CareMapprButton';
import CaremapprConfirmation from '../../../../../components/Confirmation/CaremapprConfirmation';
import { CareMapprTextField } from '../../../../../components/Inputs/textField';
import { useMedicationProfileDirty } from '../../../context/MedicationProfileDirtyProvider';

interface DoctorLetterFormProps {
  onClose: () => void;
}
const DoctorLetterForm = ({ onClose }: DoctorLetterFormProps) => {
  const {
    doctorLetterForm,
    commitDoctorLetterState,
    resetDoctorLetterToCommittedState,
  } = useLettersForm();
  const values = doctorLetterForm.watch();
  const { setIsDirty } = useMedicationProfileDirty();
  const {
    formState: { isDirty },
  } = doctorLetterForm;
  const [confirmResetOpen, setConfirmResetOpen] = React.useState(false);
  return (
    <form className="letters-form-container">
      <div className="doctor-letters-form">
        <div className="row1">
          <CareMapprTextField
            placeholder="Start typing..."
            controlId="gpName"
            label="GP name"
            value={values.gpName || ''}
            onChange={(e) => {
              doctorLetterForm.setValue('gpName', e.target.value, {
                shouldDirty: true,
              });
              setIsDirty(true);
            }}
          />
          <CareMapprTextarea
            autoResize
            placeholder="Start typing..."
            controlId="gpDetails"
            label="GP details"
            value={values.gpDetails || ''}
            onChange={(e) => {
              doctorLetterForm.setValue('gpDetails', e.target.value, {
                shouldDirty: true,
              });
              setIsDirty(true);
            }}
          />
          <CareMapprTextarea
            autoResize
            placeholder="Start typing..."
            controlId="doctor-introduction"
            label="Introduction"
            rows={4}
            value={values.introduction || ''}
            onChange={(e) => {
              doctorLetterForm.setValue('introduction', e.target.value, {
                shouldDirty: true,
              });
              setIsDirty(true);
            }}
          />
        </div>
        <div className="row2">
          <MedicationChanges type={LetterType.DOCTOR} />
          <SummaryRecommandation type={LetterType.DOCTOR} />
          <MonitoringRequired />
        </div>
        <div className="action-buttons">
          <CareMapprButton
            onClick={() => {
              if (isDirty) {
                setConfirmResetOpen(true);
              } else {
                onClose();
              }
            }}
            variant="link"
            type="button"
            style={{
              fontWeight: 'bold',
              color: 'black',
              fontSize: '14px',
              textDecoration: 'none',
            }}
          >
            Cancel & close
          </CareMapprButton>
          <CareMapprButton
            onClick={() => {
              commitDoctorLetterState();
              setIsDirty(false);
              onClose();
            }}
            type="button"
            style={{
              fontWeight: 'bold',
              color: 'black',
              fontSize: '14px',
              textDecoration: 'none',
            }}
          >
            Save
          </CareMapprButton>
        </div>
      </div>
      <CaremapprConfirmation
        open={confirmResetOpen}
        text="Reset all fields will reset all input values"
        icon="warning"
        onConfirm={() => {
          resetDoctorLetterToCommittedState();
          setIsDirty(false);
          onClose();
          setConfirmResetOpen(false);
        }}
        onClose={() => setConfirmResetOpen(false)}
        showCancelButton
      />
    </form>
  );
};

export default DoctorLetterForm;
